module.exports = __webpack_public_path__ + "static/media/Connection.77e57375.svg";